export default __webpack_public_path__ + "static/media/Jump (3).73e44877.png";